import { OrganizationLogo } from "./organization-logo.model";

export class OrganizationLogoMapper {
  public static map(organizationData: any): OrganizationLogo {
    if (!organizationData) {
      return null;
    }

    if (!organizationData.path) {
      return null;
    }

    return new OrganizationLogo(
      organizationData.originalName,
      organizationData.path,
      organizationData.height,
      organizationData.width,
      organizationData.size,
      organizationData.mimeType,
    );
  }
}
